// Amounts and days of the tensor app. Days are Korea's (design 01c 6,
// core/kst.h): "2026-10-05", months "2026-10".
import { addMonths, dayOf, entryDayLabel, monthOf, monthTitle, validDay } from '../features/tensor/tensor'

export { addMonths, dayOf, monthOf, monthTitle, validDay }

/** The server's limit (tensor.h TENSOR_AMOUNT_MAX): 1000억 원. */
export const AMOUNT_MAX = 100_000_000_000

/** "48,200원" */
export function won(n: number): string {
  return `${n < 0 ? '-' : ''}${Math.abs(n).toLocaleString('ko-KR')}원`
}

/** "48,200" without the unit (tables). */
export function num(n: number): string {
  return n.toLocaleString('ko-KR')
}

/** Won typed as "48,200", "₩48200" or "48200원"; null when empty, zero or too big. */
export function parseAmount(text: string): number | null {
  const v = text.replace(/[^0-9]/g, '')
  if (v === '' || v.length > 12) return null
  const n = Number(v)
  return n >= 1 && n <= AMOUNT_MAX ? n : null
}

/** What an amount input shows while typing: digits grouped ("48,200"). */
export function amountInput(text: string): string {
  const v = text.replace(/[^0-9]/g, '').replace(/^0+/, '').slice(0, 12)
  return v === '' ? '' : Number(v).toLocaleString('ko-KR')
}

/** Today in Korea. */
export function today(now: number = Date.now()): string {
  return dayOf(now)
}

/** "10/5(월)" */
export function dayLabel(day: string): string {
  return entryDayLabel(day)
}

/** "10월" (a short month for charts) or "2027년 1월" when the year differs. */
export function shortMonth(month: string, thisYear?: string): string {
  const [y, m] = month.split('-')
  if (thisYear !== undefined && y !== thisYear) return `${y?.slice(2)}.${Number(m)}월`
  return `${Number(m)}월`
}
